import React from "react";
import "./about.scss";
import logo from "../../Media/FotoAbout.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6282337730895&text=Halo%20Mikael,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Citraland%20City%20Kedamean%20(About)%20https://citraland-city-kedamean.id//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const about = () => {
  return (
    <div id="about" className="container-about">
      <div className="container-deskripsi">
        <div className="judulsumbog">
          <h1>Redefine Millennial Modern & Healthly Living</h1>
        </div>
        <div className="deskripsi-about">
          CitraLand City Kedamean adalah proyek perumahan skala kota mandiri
          yang dikembangkan oleh Ciputra Group. Mengusung tema "Modern
          International City", proyek ini dirancang untuk menjadi pusat kota
          baru di kawasan Gresik Selatan. Dengan total area pengembangan seluas
          200 hektar, CitraLand City Kedamean menawarkan berbagai fasilitas
          metropolitan modern untuk memenuhi gaya hidup penghuninya.Sebagai kota
          mandiri, CitraLand City Kedamean dilengkapi dengan berbagai fasilitas
          penunjang, seperti area komersial, pusat pendidikan, dan ruang terbuka
          hijau, yang dirancang untuk meningkatkan kualitas hidup penghuninya.
        </div>
      </div>
      <div className="rowcontainer">
        <div className="featurelist">
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp; Strategic Location
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp;Engage with Daily Life Activity
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp;Connecting With Nature
            </span>
          </div>

          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>&nbsp;&nbsp;Elegant Lifestyle</span>
          </div>

          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>&nbsp;&nbsp;Endless Facilities</span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp;Perfect Modern Luxury & luxurious Residence
            </span>
          </div>
          <div className="button">
            <div className="container-wa">
              <button
                className="buttonpenawaran"
                onClick={handleConsultationClick}>
                Learn More
              </button>
            </div>
          </div>
        </div>
        <div className="logo-about">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-summarecon-serpong"
          />
        </div>
      </div>
    </div>
  );
};

export default about;
